import { handleReactedForums } from "../../../redux/user-slices/forum.slice";
import { useDispatch, useSelector } from "react-redux";
import { FILE_PATH_URI } from "../../../utils/helper";
import { Link as NavLink } from "react-router-dom";
import SkeletonImage from "../../ui/SkeletonImage";
import { useEffect, useState } from "react";
import moment from "moment";

import {
  Alert,
  Avatar,
  Box,
  Divider,
  Grid2 as Grid,
  Link,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

function ForumLikes() {
  const dispatch = useDispatch();
  const [data, setdata] = useState({});
  const { loadings, refresh } = useSelector((state) => state.otherSlice);

  // Handle retrieve all forums
  const handleretrieveAll = async () => {
    const response = await dispatch(handleReactedForums({})).unwrap();
    setdata(response);
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Grid container spacing={2}>
        {loadings?.retrieveAll ? (
          new Array(4).fill().map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Skeleton
                sx={{
                  width: "100%",
                  height: "100%",
                  transform: "none",
                  aspectRatio: "1/0.5",
                }}
              />
            </Grid>
          ))
        ) : data?.records?.length === 0 ? (
          <Grid size={12}>
            <Alert
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                alignItems: "center",
                fontFamily: "Poppins",
                ".MuiAlert-message": { p: "0" },
                ".MuiAlert-icon": { fontSize: "28px" },
              }}
              color="error"
              severity="error"
            >
              No Records Found!
            </Alert>
          </Grid>
        ) : (
          data?.records?.map((element, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  gap: 1,
                  height: "100%",
                  display: "flex",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "divider",
                  flexDirection: "column",
                  transition: "all 450ms ease",
                  boxShadow: "0 0 10px 0 #0000000a",
                  ":hover": {
                    transform: "scale(1.01)",
                    boxShadow: "0 0 10px 0 #00000021",
                  },
                }}
              >
                <Box
                  sx={{
                    gap: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Avatar sx={{ width: 30, height: 30 }} />
                    <Typography
                      component="p"
                      lineHeight="1"
                      fontWeight="500"
                      whiteSpace="nowrap"
                      color="other.color1"
                      textTransform="capitalize"
                    >
                      {element?.forum?.author?.fullName}
                    </Typography>
                  </Box>
                  <Typography
                    lineHeight="1"
                    fontWeight="400"
                    component="span"
                    color="other.color2"
                    sx={{
                      display: {
                        xs: "none",
                        sm: "block",
                        md: "block",
                        xl: "block",
                      },
                    }}
                  >
                    {moment(element?.createdAt).format("MMM DD YYYY")}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: {
                      xs: "block",
                      sm: "none",
                      md: "none",
                      xl: "none",
                    },
                  }}
                >
                  <Typography
                    lineHeight="1"
                    fontWeight="400"
                    component="span"
                    color="other.color2"
                    sx={{
                      display: {
                        xs: "hidden",
                      },
                    }}
                  >
                    {moment(element?.createdAt).format("MMM DD YYYY")}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    maxHeight: "200px",
                    overflow: "hidden",
                    borderRadius: "6px",
                    aspectRatio: "1/0.6",
                  }}
                >
                  <SkeletonImage
                    src={FILE_PATH_URI + element?.forum?.banner?.path}
                  />
                </Box>

                <Stack spacing={1} sx={{ flexGrow: 1 }}>
                  <Divider />
                  <Link
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      WebkitLineClamp: 1,
                      color: "other.color1",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      transition: "all 350ms ease",
                      ":hover": {
                        color: "primary.main",
                      },
                    }}
                    fontSize={20}
                    fontWeight="500"
                    underline="hover"
                    to={`/forum/${element?.forum?._id}`}
                    component={NavLink}
                  >
                    {element?.forum?.title}
                  </Link>
                </Stack>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
}

export default ForumLikes;
